<style scoped lang="less">
	@import '../../../assets/less/base.less';
	.nav_top {
		width: 100%;
		padding: 20px 0;
		position: fixed;
		top: 0;
		height: 84px;
		box-sizing: border-box;
		z-index:999;
		:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 100%;
			background: #fff;
			top: -100%;
			left: 0;
			-webkit-backface-visibility: hidden;
			-webkit-transform-style: preserve-3d;
			transition: all .8s ease 0s;
			-ms-transition: all .8s ease 0s;
			-o-transition: all .8s ease 0s;
			-webkit-transition: all .8s ease 0s;
			-moz-transition: all .8s ease 0s;
			z-index: -1;
		}
		nav {
			width: 1200px;
			height: 44px;
			margin: 0 auto;
			.nav-logo {
				width: 188px;
				height: 38px;
				float: left;
				margin-top: 3px;
				background: url(../../../assets/images/newhomelogo.png) no-repeat center center;
				background-size: 151px 37px;
				transition: all 0.4s ease 0s;
				-ms-transition: all 0.4s ease 0s;
				-o-transition: all 0.4s ease 0s;
				-webkit-transition: all 0.4s ease 0s;
				-moz-transition: all 0.4s ease 0s;
			}
			i {
				display: block;
				width: 1px;
				height: 30px;
				float: left;
				border-left: 2px solid #FFFFFF;
				margin-top: 9px;
				transition: all 0.4s ease 0s;
				-ms-transition: all 0.4s ease 0s;
				-o-transition: all 0.4s ease 0s;
				-webkit-transition: all 0.4s ease 0s;
				-moz-transition: all 0.4s ease 0s;
			}
			.nav-title {
				width: auto;
				height: 44px;
				float: left;
				margin-left: 20px;
				span {
					height: 12px;
					line-height: 12px;
					display: block;
					color: #FFFFFF;
					font-size: 12px;
					transition: all 0.4s ease 0s;
					-ms-transition: all 0.4s ease 0s;
					-o-transition: all 0.4s ease 0s;
					-webkit-transition: all 0.4s ease 0s;
					-moz-transition: all 0.4s ease 0s;
				}
				span:first-child {
					margin-top: 8px;
				}
				span:nth-child(2) {
					margin-top: 7px;
				}
			}
			.nav {
				width: auto;
				height: 44px;
				float: left;
				margin-left: 115px;
				li {
					display: inline-block;
					float: left;
					height: 44px;
					line-height: 44px;
					padding: 0 10px;
					margin-left: 42px;
					a {
						width: 100%;
						height: 100%;
						padding: 0 10px;
						display: block;
						color: #FFFFFF;
						font-size: 16px;
						transition: all 0.4s ease 0s;
						-ms-transition: all 0.4s ease 0s;
						-o-transition: all 0.4s ease 0s;
						-webkit-transition: all 0.4s ease 0s;
						-moz-transition: all 0.4s ease 0s;
					}
					a:hover {
						transition: all 0s ease 0s;
						-ms-transition: all 0s ease 0s;
						-o-transition: all 0s ease 0s;
						-webkit-transition: all 0s ease 0s;
						-moz-transition: all 0s ease 0s;
						border-bottom: 3px solid #ffffff;
					}
				}
			}
			.nav-login {
				width: auto;
				height: 44px;
				float: right;
				box-sizing: border-box;
				color: #FFFFFF;
				// transition: all 0.4s ease 0s;
				// -ms-transition: all 0.4s ease 0s;
				// -o-transition: all 0.4s ease 0s;
				// -webkit-transition: all 0.4s ease 0s;
				// -moz-transition: all 0.4s ease 0s;
				a {
					color: #FFFFFF;
					font-size: 14px;
					line-height: 44px;
					margin: 0 10px;
					// transition: all 0.4s ease 0s;
					// -ms-transition: all 0.4s ease 0s;
					// -o-transition: all 0.4s ease 0s;
					// -webkit-transition: all 0.4s ease 0s;
					// -moz-transition: all 0.4s ease 0s;
				}
				a:hover {
					color: #dbdbdb;
				}
			}
			.router-link-active {
				border-bottom: 3px solid #ffffff;
			}
		}
	}
	/*导航动画*/

	.nav_top_change {
		width: 100%;
		padding: 20px 0;
		position: fixed;
		top: 0;
		z-index: 999999;
		height: 84px;
		box-sizing: border-box;
		/*-webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
		box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
		transition: all .8s ease 0s;
		-ms-transition: all .8s ease 0s;
		-o-transition: all .8s ease 0s;
		-webkit-transition: all .8s ease 0s;
		-moz-transition: all .8s ease 0s;*/
		:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 100%;
			background: #fff;
			top: 0;
			left: 0;
			-webkit-backface-visibility: hidden;
			-webkit-transform-style: preserve-3d;
			transition: all .8s ease 0s;
			-ms-transition: all .8s ease 0s;
			-o-transition: all .8s ease 0s;
			-webkit-transition: all .8s ease 0s;
			-moz-transition: all .8s ease 0s;
			z-index: -1;
		}
		nav {
			width: 1200px;
			height: 44px;
			margin: 0 auto;
			.nav-logo {
				width: 188px;
				height: 38px;
				float: left;
				margin-top: 3px;
				background: url(../../../assets/images/logo-Black.png) no-repeat center center;
				background-size: 151px 37px;
				transition: all 0.4s ease 0s;
				-ms-transition: all 0.4s ease 0s;
				-o-transition: all 0.4s ease 0s;
				-webkit-transition: all 0.4s ease 0s;
				-moz-transition: all 0.4s ease 0s;
			}
			i {
				display: block;
				width: 1px;
				height: 30px;
				float: left;
				border-left: 2px solid #666666;
				margin-top: 9px;
				transition: all 0.4s ease 0s;
				-ms-transition: all 0.4s ease 0s;
				-o-transition: all 0.4s ease 0s;
				-webkit-transition: all 0.4s ease 0s;
				-moz-transition: all 0.4s ease 0s;
			}
			.nav-title {
				width: auto;
				height: 44px;
				float: left;
				margin-left: 20px;
				span {
					height: 12px;
					line-height: 12px;
					display: block;
					color: #000000;
					font-size: 12px;
					transition: all 0.4s ease 0s;
					-ms-transition: all 0.4s ease 0s;
					-o-transition: all 0.4s ease 0s;
					-webkit-transition: all 0.4s ease 0s;
					-moz-transition: all 0.4s ease 0s;
				}
				span:first-child {
					margin-top: 8px;
				}
				span:nth-child(2) {
					margin-top: 7px;
				}
			}
			.nav {
				width: auto;
				height: 44px;
				float: left;
				margin-left: 115px;
				li {
					display: inline-block;
					float: left;
					height: 44px;
					line-height: 44px;
					padding: 0 10px;
					margin-left: 42px;
					a {
						width: 100%;
						height: 100%;
						padding: 0 10px;
						display: block;
						color: #666666;
						font-size: 16px;
						transition: all 0.4s ease 0s;
						-ms-transition: all 0.4s ease 0s;
						-o-transition: all 0.4s ease 0s;
						-webkit-transition: all 0.4s ease 0s;
						-moz-transition: all 0.4s ease 0s;
					}
					a:hover {
						transition: all 0s ease 0s;
						-ms-transition: all 0s ease 0s;
						-o-transition: all 0s ease 0s;
						-webkit-transition: all 0s ease 0s;
						-moz-transition: all 0s ease 0s;
						color: #333333;
						border-bottom: 3px solid #666666;
					}
				}
			}
			.nav-login {
				width: auto;
				height: 44px;
				float: right;
				box-sizing: border-box;
				color: #000000;
				transition: all 0.4s ease 0s;
				-ms-transition: all 0.4s ease 0s;
				-o-transition: all 0.4s ease 0s;
				-webkit-transition: all 0.4s ease 0s;
				-moz-transition: all 0.4s ease 0s;
				a {
					color: #000000;
					font-size: 14px;
					line-height: 44px;
					margin: 0 10px;
					transition: all 0.4s ease 0s;
					-ms-transition: all 0.4s ease 0s;
					-o-transition: all 0.4s ease 0s;
					-webkit-transition: all 0.4s ease 0s;
					-moz-transition: all 0.4s ease 0s;
				}
				a:hover {
					color: #999999;
				}
			}
			.router-link-active {
				color: #333333 !important;
				border-bottom: 3px solid #666666;
			}
		}
	}
</style>
<template>
	<div :class="local?'nav_top':'nav_top_change'" style="position: fixed;">
		<nav>
			<div class="nav-logo">
			</div>
			<i></i>
			<div class="nav-title">
				<span>移动</span>
				<span>广告平台</span>
			</div>
			<ul class="nav">
				<li>
					<router-link to="/" exact>首页</router-link>
				</li>
				<li>
					<router-link to="/publish">流量主</router-link>
				</li>
				<li>
					<router-link to="/advertiser">广告主</router-link>
				</li>
				<li>
					<router-link to="/sdk">产品中心</router-link>
				</li>
				<li>
					<router-link to="/about">关于我们</router-link>
				</li>

			</ul>
			<div class="nav-login">
				<router-link to="/account/login">登录</router-link>|
				<router-link to="/account/register">注册</router-link>
			</div>
		</nav>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				navshow: true,
				local: true
			};
		},
		methods: {
			btn_pos: function() {
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				if(scrollTop > 84) {
					this.local = false
				} else if(scrollTop < 80) {
					this.local = true
				}
			}
		},
		created() {

		},
		mounted() {
			window.addEventListener('scroll', this.btn_pos)
		},
		destroyed() {
			window.removeEventListener('scroll', this.btn_pos)
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/NewHome/common/Newnav.vue